import React from 'react';
import { Box } from '@mui/material';
import ContactSupportButton from '../ContactSupportButton';

interface HelpPageHeaderActionsProps {
  organizationId: string;
}

const HelpPageHeaderActions: React.FC<HelpPageHeaderActionsProps> = ({ organizationId }) => (
  <Box sx={{ display: 'none' }} aria-hidden>
    <ContactSupportButton organizationId={organizationId} variant="inline" />
  </Box>
);

export default HelpPageHeaderActions;
